import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import apiClient from '../api/client';
import './IncluirRebuy.css';

/**
 * Página para Admin adicionar rebuy
 */

const IncluirRebuy = () => {
  const { isAdmin } = useAuth();
  const navigate = useNavigate();
  const [rodadaAberta, setRodadaAberta] = useState(null);
  const [jogadoresConfirmados, setJogadoresConfirmados] = useState([]);
  const [jogadorSelecionado, setJogadorSelecionado] = useState('');
  const [tipoRebuy, setTipoRebuy] = useState('simples');
  const [loading, setLoading] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isAdmin) {
      navigate('/dashboard');
      return;
    }
    carregarDados();
  }, [isAdmin, navigate]);

  const carregarDados = async () => {
    try {
      setLoading(true);
      setError('');

      const rodadasRes = await apiClient.get('/rodadas');
      const rodadas = Array.isArray(rodadasRes.data) ? rodadasRes.data : [];
      const aberta = rodadas.find(r => r.status === 'aberta');

      if (!aberta) {
        setError('Não há rodada aberta. Abra uma rodada primeiro.');
        setLoading(false);
        return;
      }

      setRodadaAberta(aberta);

      // Carregar confirmações
      const confirmacoesRes = await apiClient.get(`/rodadas/${aberta.id}/confirmacoes`);
      const confirmacoes = Array.isArray(confirmacoesRes.data) ? confirmacoesRes.data : [];
      setJogadoresConfirmados(confirmacoes);

    } catch (err) {
      console.error('Erro ao carregar dados:', err);
      setError(err.response?.data?.error || 'Erro ao carregar dados');
    } finally {
      setLoading(false);
    }
  };

  const handleAdicionarRebuy = async (e) => {
    e.preventDefault();
    
    if (!jogadorSelecionado) {
      setError('Selecione um jogador');
      return;
    }

    try {
      setSalvando(true);
      setError('');

      await apiClient.post(`/rodadas/${rodadaAberta.id}/rebuy`, {
        jogador_id: jogadorSelecionado,
        tipo: tipoRebuy,
      });

      alert(`Rebuy ${tipoRebuy === 'simples' ? 'simples' : 'duplo'} adicionado com sucesso!`);
      setJogadorSelecionado('');
    } catch (err) {
      console.error('Erro ao adicionar rebuy:', err);
      setError(err.response?.data?.error || 'Erro ao adicionar rebuy');
    } finally {
      setSalvando(false);
    }
  };

  if (loading) {
    return <div className="container">Carregando...</div>;
  }

  if (!rodadaAberta) {
    return (
      <div className="container">
        <div className="error">Não há rodada aberta. Abra uma rodada primeiro.</div>
        <button onClick={() => navigate('/rodadas')} className="btn btn-primary">
          Ir para Rodadas
        </button>
      </div>
    );
  }

  return (
    <div className="container incluir-rebuy-container">
      <div className="page-header">
        <h1>🔄 Incluir Rebuy</h1>
        <button onClick={() => navigate('/admin/menu')} className="btn btn-secondary">
          ← Voltar
        </button>
      </div>

      <div className="rodada-info">
        <p><strong>Rodada:</strong> {new Date(rodadaAberta.data).toLocaleDateString('pt-BR')}</p>
      </div>

      {error && <div className="error">{error}</div>}

      <form onSubmit={handleAdicionarRebuy} className="rebuy-form">
        <div className="form-group">
          <label>Jogador *</label>
          <select
            value={jogadorSelecionado}
            onChange={(e) => setJogadorSelecionado(e.target.value)}
            required
          >
            <option value="">Selecione o jogador...</option>
            {jogadoresConfirmados.map(c => (
              <option key={c.jogador_id} value={c.jogador_id}>
                {c.jogador?.nome || 'Jogador'}
              </option>
            ))}
          </select>
          <small>Selecione um jogador confirmado na rodada</small>
        </div>

        <div className="form-group">
          <label>Tipo de Rebuy *</label>
          <div className="radio-group">
            <label>
              <input
                type="radio"
                value="simples"
                checked={tipoRebuy === 'simples'}
                onChange={(e) => setTipoRebuy(e.target.value)}
              />
              {' '}Simples (R$ 25,00)
            </label>
            <label>
              <input
                type="radio"
                value="duplo"
                checked={tipoRebuy === 'duplo'}
                onChange={(e) => setTipoRebuy(e.target.value)}
              />
              {' '}Duplo (R$ 40,00)
            </label>
          </div>
        </div>

        <div className="form-actions">
          <button type="submit" disabled={salvando} className="btn btn-primary">
            {salvando ? 'Adicionando...' : 'Adicionar Rebuy'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default IncluirRebuy;
